export const GET_STOPPAGE_REPORTS = "GET_STOPPAGE_REPORTS";
export const EXPORT_STOPPAGE_REPORTS = "EXPORT_STOPPAGE_REPORTS";
export const GET_VEHICLE_DROPDOWN = "GET_VEHICLE_DROPDOWN";
export const GET_ASSET_GROUP_DROPDOWN = "GET_ASSET_GROUP_DROPDOWN";
export const GET_DAILY_REPORTS = "GET_DAILY_REPORTS";
export const GET_TRIP_REPORTS = "GET_TRIP_REPORTS";
export const GET_SCHOOL_ALERT_REPORTS = "GET_SCHOOL_ALERT_REPORTS";
export const GET_SCHOOL_AREAFENCE_REPORTS = "GET_SCHOOL_AREAFENCE_REPORTS";
export const GET_SCHOOL_OVERSPEED_REPORTS = "GET_SCHOOL_OVERSPEED_REPORTS";
export const GET_USER_DROPDOWN = "GET_USER_DROPDOWN";
export const PANIC_HISTORY_REPORT = "PANIC_HISTORY_REPORT";
export const GET_AREAFENCE_DATA = "GET_AREAFENCE_DATA";
export const SET_ORGANIZATION_AREAFENCE = "SET_ORGANIZATION_AREAFENCE";
export const DELETE_ORGANIZATION_AREAFENCE_STATUS =
  "DELETE_ORGANIZATION_AREAFENCE_STATUS";
export const GET_TRIP_CONFIGURATION = "GET_TRIP_CONFIGURATION";
export const UPDATE_TRIP_CONFIGURATION_STATUS =
  "UPDATE_TRIP_CONFIGURATION_STATUS";
export const SET_TRIP_CONFIGURATION = "SET_TRIP_CONFIGURATION";
export const GET_TRIP_RULES = "GET_TRIP_RULES";
export const SET_TRIP_RULE = "SET_TRIP_RULE";
export const UPDATE_TRIP_RULE_STATUS = "UPDATE_TRIP_RULE_STATUS";
export const GET_TRIP_TYPES = "GET_TRIP_TYPES";
export const GET_TRIP_CONFIG_VEHICLE_ASSOC_DETAILS =
  "GET_TRIP_CONFIG_VEHICLE_ASSOC_DETAILS";
export const SET_TRIP_CONFIG_VEHICLE_ASSOC = "SET_TRIP_CONFIG_VEHICLE_ASSOC";
export const UPDATE_TRIP_CONFIG_VEHICLE_ASSOC_STATUS =
  "UPDATE_TRIP_CONFIG_VEHICLE_ASSOC_STATUS";
